import './spinner.component.scss';

import { Component } from 'preact';

interface SpinnerProps {
  size?: 'small' | 'large';
}

export class SpinnerComponent extends Component<SpinnerProps> {
  render() {
    const { size = 'large' } = this.props;
    const dimension = size === 'small' ? 22 : 44;
    const sizeClass = size === 'small' ? 'single-spinner-small' : 'single-spinner-large';

    return (
      <div className={`single-spinner ${sizeClass}`}>
        <svg
          width={dimension}
          height={dimension}
          viewBox={`0 0 ${dimension} ${dimension}`}
          xmlns="http://www.w3.org/2000/svg"
          stroke="currentColor"
          class={`single-spinner-inner ${sizeClass}`}
        >
          <g fill="none" fill-rule="evenodd" stroke-width="2">
            <circle cx={dimension / 2} cy={dimension / 2} r="1">
              <animate
                attributeName="r"
                begin="0s"
                dur="1.8s"
                values={`1; ${dimension / 2.2}`}
                calcMode="spline"
                keyTimes="0; 1"
                keySplines="0.165, 0.84, 0.44, 1"
                repeatCount="indefinite"
              />
              <animate
                attributeName="stroke-opacity"
                begin="0s"
                dur="1.8s"
                values="1; 0"
                calcMode="spline"
                keyTimes="0; 1"
                keySplines="0.3, 0.61, 0.355, 1"
                repeatCount="indefinite"
              />
            </circle>
            <circle cx={dimension / 2} cy={dimension / 2} r="1">
              <animate
                attributeName="r"
                begin="-0.9s"
                dur="1.8s"
                values={`1; ${dimension / 2.2}`}
                calcMode="spline"
                keyTimes="0; 1"
                keySplines="0.165, 0.84, 0.44, 1"
                repeatCount="indefinite"
              />
              <animate
                attributeName="stroke-opacity"
                begin="-0.9s"
                dur="1.8s"
                values="1; 0"
                calcMode="spline"
                keyTimes="0; 1"
                keySplines="0.3, 0.61, 0.355, 1"
                repeatCount="indefinite"
              />
            </circle>
          </g>
        </svg>
      </div>
    );
  }
}
